export default {
  PublicChannel: 99
}
